import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder } from "ticketino-api-client";

import Header from "./components/Header";

const INTEREST_OPTIONS = [
    "Alternative Investments", "Commodities", "Company Pension Plans", "Crypto", "Digital Assets", "Equities", "ESG / Sustainability / Impact Investing",
    "Fintec", "Fixed Income / Convertibles", "Hedge Funds", "Insurance Products", "Investment Strategies", "Passive Instruments / ETF/ ETP", "Politics / Economics",
    "Private Markets", "Real Estate / Mortgages / Infrastructure", "Regulation / Fund Services", "Structured Products"
];

const CREDITPOINTS_OPTIONS = [
    "Kein Interesse",
    "SPKE",
    "CFA",
    "SAV",
    "VSV"
];

const Visitor_Step10_Interests = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [organizerId, setOrganizerId] = useState(0);

    const [selectedInterests, setSelectedInterests] = useState([]);
    const [otherInterest, setOtherInterest] = useState("");
    const [dropdownValue, setDropdownValue] = useState(CREDITPOINTS_OPTIONS[0]);

    const [buyerInfo, setBuyerInfo] = useState({
        code3: "",
        code4: "",
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    const isNextDisabled =
        selectedInterests.length === 0 ||
        (selectedInterests.includes("Other") && otherInterest.trim() === "") ||
        dropdownValue === "";

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId);
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate("/de/visitor/home");
                }

                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/de/visitor/home");
            }
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder === null) {
                navigate("/de/visitor/home")
            }

            setOrder(updatedOrder);
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleInterestChange = (interest) => {
        setSelectedInterests((prev) =>
            prev.includes(interest)
                ? prev.filter((i) => i !== interest)
                : [...prev, interest]
        );
    };

    const handleOtherCheckbox = () => {
        if (selectedInterests.includes("Other")) {
            setSelectedInterests(selectedInterests.filter(i => i !== "Other"));
            setOtherInterest("");
        } else {
            setSelectedInterests([...selectedInterests, "Other"]);
        }
    };

    const handleOtherInput = (e) => {
        setOtherInterest(e.target.value);
    };

    const handleDropdownChange = (e) => {
        setDropdownValue(e.target.value);
    };

    const onSubmit = async () => {
        let interestsToStore = selectedInterests.filter(i => i !== "Other");
        if (selectedInterests.includes("Other") && otherInterest.trim() !== "") {
            interestsToStore.push("other: " + otherInterest.trim());
        }
        const updatedBuyerInfo = { ...buyerInfo, interests: interestsToStore.join(","), creditPoint: dropdownValue };
        setBuyerInfo(updatedBuyerInfo);
        await addAddressToBasket(updatedBuyerInfo);
    }

    const addAddressToBasket = async (buyerInfoToSend = buyerInfo) => {
        // Retrieve existing addressBody from localStorage
        let existingAddressBody = {};
        try {
            existingAddressBody = JSON.parse(localStorage.getItem("addressBody")) || {};
        } catch (e) {
            existingAddressBody = {};
        }

        // Merge new fields with existing ones
        let addressBody = {
            ...existingAddressBody,
            code3: buyerInfoToSend.interests, // store all selected interests in one field
            code4: buyerInfoToSend.creditPoint
        };

        // Save updated addressBody to localStorage
        localStorage.setItem("addressBody", JSON.stringify(addressBody));

        // Navigate to the next step
        navigate(`/${language}/visitor/contact-details`);
    };

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">

                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <span className="text-subtitle d-block">{resources?.VisitorInterestsTitle}</span>
                        <div className="mt-2">
                            <span>{resources?.VisitorInterestsDesc1}</span> <i className="text-secondary">{resources?.VisitorInterestsDesc2}</i>
                        </div>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-8">
                        {/* Interests checkboxes */}
                        <div>
                            {INTEREST_OPTIONS.map((interest, idx) => (
                                <label
                                    key={idx}
                                    className={`d-flex align-items-center mb-2${selectedInterests.includes(interest) ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedInterests.includes(interest)}
                                        onChange={() => handleInterestChange(interest)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${selectedInterests.includes(interest) ? "-check" : ""}-square me-2`}></i>
                                    <span>{interest}</span>
                                </label>
                            ))}
                            {/* Other checkbox */}
                            <label
                                className={`d-flex align-items-center mb-2${selectedInterests.includes("Other") ? ' selected-interest' : ''}`}
                                style={{ cursor: "pointer" }}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedInterests.includes("Other")}
                                    onChange={handleOtherCheckbox}
                                    className="d-none"
                                />
                                <i className={`bi bi${selectedInterests.includes("Other") ? "-check" : ""}-square me-2`}></i>
                                <span>Other:</span>
                                <input
                                    type="text"
                                    className="form-control ms-2"
                                    style={{ maxWidth: 200, height: "35px" }}
                                    value={otherInterest}
                                    onChange={handleOtherInput}
                                    disabled={!selectedInterests.includes("Other")}
                                />
                            </label>
                        </div>
                    </div>
                </div>

                {/* Credit points */}
                <div className="row mt-4">
                    <div className="col-md-12">
                        <span className="text-subtitle d-block">{resources?.VisitorInterestsCreditPointsTitle}</span>
                        <div className="mt-2">
                            <span>{resources?.VisitorInterestsCreditPointsDesc}</span>
                        </div>
                    </div>
                </div>

                {/* Credit points - dropdownlist */}
                <div className="row mt-3"> 
                    <div className="col-md-4">
                        <div className="mb-3">
                            <select
                                id="interestDropdown"
                                className="form-select"
                                value={dropdownValue}
                                onChange={handleDropdownChange}
                            >
                                {CREDITPOINTS_OPTIONS.map((option, idx) => (
                                    <option key={idx} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <p dangerouslySetInnerHTML={{ __html: resources?.VisitorInterestsImportantInfos }}></p>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-6">
                        <button className="btn button-custom" onClick={() => navigate(-1)}>{resources?.Back}</button>
                    </div>
                    <div className="col-md-6 text-end">
                        <button className="btn button-custom" onClick={() => onSubmit()} disabled={isNextDisabled}>{resources?.Next}</button>
                    </div>
                </div>

                <p className="mt-4">
                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                </p>
            </div>
        </div>
    )
}

export default Visitor_Step10_Interests